import api from './api';
import { postDelivery } from './deliveryOperationState';

export function getMessageThreads(params) {
  return api.get('/messages/threads', { params });
}

export function getMessageThread(id) {
  return api.get(`/messages/threads/${id}`);
}

export function replyToThread(id, body) {
  return postDelivery('sms', id, `/messages/threads/${id}/reply`, { body });
}

export function startConversation(data) {
  // The target key contains identifiers only; message text is never persisted.
  return postDelivery('sms', `start:${data.location_id}:${data.patient_id || data.referral_id || 'new-contact'}`, '/messages/start', data);
}

export function getMessagesUnreadCount(locationId) {
  return api.get('/messages/unread-count', { params: locationId ? { location_id: locationId } : {} });
}

export function setThreadStatus(id, status) {
  return api.patch(`/messages/threads/${id}`, { status });
}

// Move a conversation to a different office.
export function setThreadLocation(id, locationId) {
  return api.patch(`/messages/threads/${id}/location`, { location_id: locationId });
}

// Quick-reply templates
export function getMessageTemplates(activeOnly) {
  return api.get('/messages/templates', { params: activeOnly ? { active: 1 } : {} });
}
export function createMessageTemplate(data) {
  return api.post('/messages/templates', data);
}
export function updateMessageTemplate(id, data) {
  return api.patch(`/messages/templates/${id}`, data);
}
export function deleteMessageTemplate(id) {
  return api.delete(`/messages/templates/${id}`);
}

// Resolve {merge_fields} in a template body against the available context.
export function applyTemplateMerge(body, ctx = {}) {
  return String(body || '')
    .replace(/\{first_name\}/gi, ctx.first_name || '')
    .replace(/\{last_name\}/gi, ctx.last_name || '')
    .replace(/\{office_name\}/gi, ctx.office_name || '')
    .replace(/\{office_phone\}/gi, ctx.office_phone || '')
    .trim();
}
